import React from "react";
import {
  TEACHER_ROUND_BUTTONS,
  TEACHER_ROUND_GROUPS,
  groupRoundButtons,
} from "../../config/admissionRound";
import { attachRoundMeta } from "./quotaRounds";
import RoundImageRows from "./RoundImageRows";
import RoundCaption from "./RoundCaption";

/* ---------------------------------------------------------------------------
 * รูปปุ่มชั่วคราว — ยืมของภาคปกติ (/Register/1) มาใช้ก่อนระหว่างรอนักออกแบบ
 *
 * เมื่อได้ไฟล์จริงแล้วให้วางที่ src/assets/2027/teacher/ แล้วแก้ import ล่างนี้
 * สเปกไฟล์: PNG พื้นโปร่ง 1024 x 512 px (สัดส่วน 2:1) — CSS ย่อให้กว้างสุด 300 px
 *
 * key ของรูปต้องตรงกับ key ใน TEACHER_ROUND_BUTTONS
 * ------------------------------------------------------------------------- */
import rob1 from "../../assets/2027/normall/rob1.png";
import rob2 from "../../assets/2027/normall/rob2.png";

const IMAGES = { trob1: rob1, trob2: rob2 };

/**
 * ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู — /Register/5
 * เปิด-ปิดปุ่มแก้ที่ TEACHER_ROUND_BUTTONS ใน config/admissionRound.js
 * ส่วนวันรับสมัครใต้ปุ่มดึงจาก API ตาม ROB_ID
 */
function TeacherCertRounds({ rounds, selectedRobId, onSelect }) {
  const groups = attachRoundMeta(
    groupRoundButtons(TEACHER_ROUND_BUTTONS, TEACHER_ROUND_GROUPS, IMAGES),
    rounds
  );

  if (groups.length === 0) {
    return <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>;
  }

  return (
    <RoundImageRows
      groups={groups}
      selectedRobId={selectedRobId}
      onSelect={onSelect}
      renderCaption={(round) => <RoundCaption round={round} />}
    />
  );
}

export default TeacherCertRounds;
